<div class="team-add-main-container">
  <ng-scrollbar [autoHeightDisabled]="false" [autoWidthDisabled]="false" fxFlex="auto">
    <div class="scroll-content">
      <form [formGroup]="teamForm" class="form-content">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex>
          <mat-label>Team Name</mat-label>
          <input
            matInput
            forbidAngleBrackets
            type="text"
            formControlName="name"
            placeholder="Required"
            id="team-name-input"
          />
          <mat-error *ngIf="teamForm.get('name').hasError('unique')">
            {{ teamForm.get('name').getError('unique') }}
          </mat-error>
          <mat-error *ngIf="teamForm.get('name').hasError('notEmpty')">
            {{ teamForm.get('name').getError('notEmpty') }}
          </mat-error>
          <mat-error *ngIf="teamForm.get('name').hasError('minlength')">
            Team name must be at least 4 characters
          </mat-error>
          <mat-error *ngIf="teamForm.get('name').hasError('maxlength')">
            Team name can be at most 255 characters
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always" fxFlex>
          <mat-label>Public Name</mat-label>
          <input matInput forbidAngleBrackets type="text" formControlName="publicName" id="public-team-name-input" />
          <mat-error *ngIf="teamForm.get('publicName').hasError('minlength')">
            Team name must be at least 4 characters
          </mat-error>
          <mat-error *ngIf="teamForm.get('publicName').hasError('maxlength')">
            Team name can be at most 255 characters
          </mat-error>
        </mat-form-field>
        <div fxLayoutAlign="space-between" formGroupName="dateGroup">
          <mat-form-field appearance="outline" floatLabel="always" fxFlex="47%">
            <mat-label>Start Date</mat-label>
            <input
              matInput
              [matDatepicker]="startPicker"
              formControlName="startDate"
              placeholder="Optional"
              [errorStateMatcher]="matcher"
              id="team-startdate-input"
            />
            <mat-datepicker-toggle matSuffix [for]="startPicker"> </mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            <mat-error *ngIf="dateFormGroup.hasError('startDateBeforeEndDate')">
              Start date must be before the end date
            </mat-error>
            <mat-error *ngIf="dateFormGroup.hasError('requiredStartDate')">
              Start date is required if an end date is set
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always" fxFlex="47%">
            <mat-label>End Date</mat-label>
            <input
              matInput
              [matDatepicker]="endPicker"
              formControlName="endDate"
              placeholder="Optional"
              id="team-enddate-input"
            />
            <mat-datepicker-toggle matSuffix [for]="endPicker"> </mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <mat-divider *ngIf="attributesDataSource.hasAttributes"></mat-divider>
        <ng-container *ngIf="attributesDataSource.hasAttributes">
          <attributes-editor
            [dataSource]="attributesDataSource"
            [onTeamForm]="true"
            [mode]="teamDetailsMode"
            fxFlexWidth="100%"
          >
          </attributes-editor>
        </ng-container>
        <mat-divider *ngIf="attributesDataSource.hasAttributes"></mat-divider>
        <mat-list formArrayName="positions">
          <h3 matSubheader>Positions</h3>
          <mat-list-item *ngFor="let positionFormGroup of positionFormGroups; let i = index" [formGroupName]="i">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex class="position-title">
              <input
                matInput
                forbidAngleBrackets
                type="text"
                placeholder="Title"
                formControlName="title"
                id="position-title-input"
              />
              <mat-error *ngIf="positionFormGroup.get('title').hasError('notEmpty')">
                {{ positionFormGroup.get('title').getError('notEmpty') }}
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="18%" class="position-count">
              <input
                matInput
                type="number"
                min="1"
                placeholder="Seats"
                formControlName="count"
                id="position-count-input"
              />
            </mat-form-field>
            <div fxFlex="40px">
              <button
                class="delete-position"
                mat-icon-button
                (click)="removePosition(i)"
                type="button"
                aria-label="Delete position"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-list-item>
        </mat-list>
        <div>
          <button
            class="add-position-button"
            mat-button
            color="primary"
            (click)="addPosition()"
            type="button"
            aria-label="Add another position"
          >
            <mat-icon>add</mat-icon>POSITION
          </button>
        </div>
      </form>
    </div>
  </ng-scrollbar>
</div>
